const overviewMockData = {
    rework: {
        total: {
            value: 0.5,
        },
        breakdown: {
            commits: 7813,
            lines: 1019831,
            reworkLines: 513119,
            nonReworkLines: 506712,
            reworkLinesRatio: 0.5,
        },
        meta: {
            accuracy: {
                level: "high",
                dependencies: [
                    {
                        type: "integration",
                        name: "git",
                        impact: "very-high",
                        fulfilled: true,
                    },
                ],
            },
        },
        stats: {
            slope: 0.06927,
        },
    },
    throughput: {
        breakdown: {
            throughputGit: 1015,
            throughputPm: 874,
            throughputGitPerUserAvg: 68.3,
            throughputPmPerUserAvg: 49.1,
            throughputGitPerUserMedian: 57,
            throughputPmPerUserMedian: 36,
        },
        meta: {
            accuracy: {
                level: "high",
                dependencies: [
                    {
                        type: "integration",
                        name: "git",
                        impact: "high",
                        fulfilled: true,
                    },
                    {
                        type: "integration",
                        name: "pm",
                        impact: "high",
                        fulfilled: true,
                    },
                ],
            },
        },
        stats: {
            throughputGitSlope: -0.0075,
            throughputPmSlope: 0.019,
        },
    },
    leadTime: {
        breakdown: {
            leadTimeGit: 440430.16,
            leadTimePm: 2694381.09,
            leadTimeGitAdj: 207599.5,
            leadTimePmAdj: 1363455.81,
            leadTimeGitMedian: 68039,
            leadTimeGit90th: 1137936,
            leadTimeGit95th: 1899546,
            leadTimePmMedian: 863782,
            leadTimePm90th: 5176315,
            leadTimePm95th: 9007684,
        },
        meta: {
            accuracy: {
                level: "high",
                dependencies: [
                    {
                        type: "integration",
                        name: "git",
                        impact: "high",
                        fulfilled: true,
                    },
                    {
                        type: "integration",
                        name: "pm",
                        impact: "high",
                        fulfilled: true,
                    },
                ],
            },
        },
        stats: {
            leadTimeSlopeGit: 0.0381,
            leadTimeSlopePm: 0.0981,
        },
    },
    reviewTime: {
        breakdown: {
            reviewToMergeTimeGit: 304066.7,
            reviewToMergeTimeGitAdj: 155085.22,
            reviewToMergeTimeGitMedian: 49933,
            reviewToMergeTimeGit90th: 777199,
            reviewToMergeTimeGit95th: 1205767,
        },
        meta: {
            accuracy: {
                level: "high",
                dependencies: [
                    {
                        type: "integration",
                        name: "git",
                        impact: "very-high",
                        fulfilled: true,
                    },
                ],
            },
        },
        stats: {
            slope: 0.01927,
        },
    },
    scopeCreep: {
        total: {
            value: 19,
        },
        breakdown: {
            sprintsCount: 29,
            planned: 41,
            total: 60,
            sprints: [
                {
                    sprintName: "CP Sprint 1",
                    sprintId: "18",
                    issuesPreplanned: 0,
                    scopeCreep: 7,
                    total: 7,
                },
                {
                    sprintName: "v1.4.0 Sprint 1",
                    sprintId: "42",
                    issuesPreplanned: 0,
                    scopeCreep: 83,
                    total: 83,
                },
            ],
        },
        meta: {
            accuracy: {
                level: "high",
                dependencies: [
                    {
                        type: "integration",
                        name: "pm",
                        impact: "very-high",
                        fulfilled: true,
                    },
                ],
            },
        },
        stats: {
            slope: 0.01927,
        },
    },
    bugsDetected: {
        total: {
            value: 195,
        },
        breakdown: {
            issuePoints: 1,
            prodIssues: 99,
            prodIssuePoints: null,
            totalIssues: 1028,
            totalIssuePoints: 110,
            totalProdIssues: 525,
            totalProdIssuePoints: 63,
        },
        meta: {
            accuracy: {
                level: "high",
                dependencies: [
                    {
                        type: "integration",
                        name: "pm",
                        impact: "very-high",
                        fulfilled: true,
                    },
                ],
            },
        },
        stats: {
            slope: 0.01927,
        },
    },
    codeSilos: {
        total: {
            value: 10,
        },
        breakdown: [
            {
                singlePersonRatio: 1,
                repoName: "adadot / causal",
                commits: 6,
                commitTs: "2024-10-14 12:51:54",
                slope: 0.01927,
            },
            {
                singlePersonRatio: 1,
                repoName: "adadot / Code Quality",
                commits: 49,
                commitTs: "2024-11-14 16:36:44",
                slope: 0.01927,
            },
            {
                singlePersonRatio: 1,
                repoName: "adadot / Data Science Projects / Flow Analysis Sagemaker",
                commits: 37,
                commitTs: "2024-05-29 09:05:31",
                slope: 0.01927,
            },
            {
                singlePersonRatio: 0.69,
                repoName: "adadot / frontend-b2b",
                commits: 60,
                commitTs: "2024-11-04 11:42:37",
                slope: 0.01927,
            },
            {
                singlePersonRatio: 0.67,
                repoName: "adadot / Frontend B2C",
                commits: 3082,
                commitTs: "2024-11-21 11:19:58",
                slope: 0.01927,
            },
            {
                singlePersonRatio: 1,
                repoName: "adadot / Frontend Static",
                commits: 121,
                commitTs: "2024-11-21 15:02:27",
                slope: 0.01927,
            },
            {
                singlePersonRatio: 1,
                repoName: "adadot / Github Events Webhooks",
                commits: 63,
                commitTs: "2024-10-30 08:09:24",
                slope: 0.01927,
            },
            {
                singlePersonRatio: 1,
                repoName: "adadot / Service Events Webhooks",
                commits: 60,
                commitTs: "2024-10-30 07:56:04",
                slope: 0.01927,
            },
            {
                singlePersonRatio: 0.76,
                repoName: "adadot / slack",
                commits: 220,
                commitTs: "2024-10-30 09:42:38",
                slope: 0.01927,
            },
        ],
        meta: {
            accuracy: {
                level: "high",
                dependencies: [
                    {
                        type: "integration",
                        name: "git",
                        impact: "very-high",
                        fulfilled: true,
                    },
                ],
            },
        },
        stats: {
            slope: 0.01927,
        },
    },
    backlog: {
        total: {
            value: 746,
        },
        breakdown: {
            issuePoints: 40,
            newIssues: 306,
            newIssuePoints: 19,
            prodIssues: 24,
            prodIssuePoints: null,
            prodNewIssues: 9,
            prodNewIssuePoints: null,
        },
        meta: {
            accuracy: {
                level: "high",
                dependencies: [
                    {
                        type: "integration",
                        name: "pm",
                        impact: "very-high",
                        fulfilled: true,
                    },
                ],
            },
        },
        stats: {
            slope: -0.03927,
        },
    },
    bugsBacklog: {
        total: {
            value: 41,
        },
        breakdown: {
            bugPoints: null,
            newBugIssues: 13,
            newBugPoints: null,
            prodBugIssues: 22,
            prodBugPoints: null,
            prodNewBugIssues: 7,
            prodNewBugPoints: null,
        },
        meta: {
            accuracy: {
                level: "high",
                dependencies: [
                    {
                        type: "integration",
                        name: "pm",
                        impact: "very-high",
                        fulfilled: true,
                    },
                ],
            },
        },
        stats: {
            slope: 0.01927,
        },
    },
    code: {
        total: {
            value: 20200.969696969696,
        },
        breakdown: {
            total: 65333259,
            avgPerDay: 494948.9318181818,
            avgPerUser: 2613332,
            avgPerUserDay: 19797.969696969696,
        },
        meta: {
            accuracy: {
                level: "high",
                dependencies: [
                    {
                        type: "integration",
                        name: "calendar",
                        impact: "very-high",
                        fulfilled: true,
                    },
                    {
                        type: "integration",
                        name: "slack",
                        impact: "medium",
                        fulfilled: true,
                    },
                ],
            },
        },
        stats: {
            slope: 0.04927,
        },
    },
    collaboration: {
        total: {
            value: 800.992424242424,
        },
        breakdown: {
            total: 23215564,
            avgPerDay: 175875.48484848483,
            avgPerUser: 928619,
            avgPerUserDay: 7034.992424242424,
        },
        meta: {
            accuracy: {
                level: "high",
                dependencies: [
                    {
                        type: "integration",
                        name: "calendar",
                        impact: "very-high",
                        fulfilled: true,
                    },
                    {
                        type: "integration",
                        name: "slack",
                        impact: "medium",
                        fulfilled: true,
                    },
                ],
            },
        },
        stats: {
            slope: 0.02927,
        },
    },
    balance: {
        total: {
            value: 2558.2727272727275,
        },
        breakdown: {
            outOfOfficeBreak: 8442300,
            avgPerDayOutOfOfficeBreak: 63956.818181818184,
            avgPerUserOutOfOfficeBreak: 337692,
            avgPerUserDayOutOfOfficeBreak: 2558.2727272727275,
            outOfOffice: 6741000,
            avgPerDayOutOfOffice: 51068.181818181816,
            avgPerUserOutOfOffice: 269640,
            avgPerUserDayOutOfOffice: 2042.7272727272727,
            break: 1701300,
            avgPerDayBreak: 12888.636363636364,
            avgPerUserBreak: 68052,
            avgPerUserDayBreak: 515.5454545454545,
        },
        meta: {
            accuracy: {
                level: "high",
                dependencies: [
                    {
                        type: "integration",
                        name: "calendar",
                        impact: "very-high",
                        fulfilled: true,
                    },
                    {
                        type: "integration",
                        name: "slack",
                        impact: "medium",
                        fulfilled: true,
                    },
                ],
            },
        },
        stats: {
            slope: 0.07927,
        },
    },
    longHours: {
        total: {
            value: 299.81060606060606,
        },
        breakdown: {
            total: 989443,
            avgPerUser: 39575,
            avgPerDay: 7495.780303030303,
            avgPerUserDay: 299.81060606060606,
        },
        meta: {
            accuracy: {
                level: "very-low",
                dependencies: [
                    {
                        type: "integration",
                        name: "calendar",
                        impact: "very-high",
                        fulfilled: true,
                    },
                    {
                        type: "integration",
                        name: "slack",
                        impact: "medium",
                        fulfilled: true,
                    },
                    {
                        type: "integration",
                        name: "git",
                        impact: "high",
                        fulfilled: true,
                    },
                ],
            },
        },
        stats: {
            slope: -0.01927,
        },
    },
    outOfHours: {
        total: {
            value: 1593.628787878788,
        },
        breakdown: {
            total: 5259001,
            avgPerUser: 210359,
            avgPerDay: 39840.916666666664,
            avgPerUserDay: 1593.628787878788,
        },
        meta: {
            accuracy: {
                level: "very-low",
                dependencies: [
                    {
                        type: "integration",
                        name: "calendar",
                        impact: "very-high",
                        fulfilled: true,
                    },
                    {
                        type: "integration",
                        name: "slack",
                        impact: "medium",
                        fulfilled: true,
                    },
                    {
                        type: "integration",
                        name: "git",
                        impact: "high",
                        fulfilled: true,
                    },
                ],
            },
        },
        stats: {
            slope: -0.06927,
        },
    },
    focus: {
        total: {
            value: 16960.454545454544,
        },
        breakdown: {
            total: 55969487,
            perDay: 424011.26515151514,
            perUser: 2238780,
            perUserDay: 16960.454545454544,
        },
        meta: {
            accuracy: {
                level: "high",
                dependencies: [
                    {
                        type: "integration",
                        name: "calendar",
                        impact: "very-high",
                        fulfilled: true,
                    },
                    {
                        type: "integration",
                        name: "slack",
                        impact: "medium",
                        fulfilled: true,
                    },
                ],
            },
        },
        stats: {
            slope: 0.01927,
        },
    },
    cachedAt: "2024-12-13T15:47:12.694Z",
    maintainability: {
        total: {
            value: 21.46,
        },
        codeQualityEnabled: true,
        breakdown: [
            {
                maintainability_index: 39.903,
                hostname_repo_full_name: "adadot / Backend Server",
                maintainability_influence: 0.573,
            },
            {
                maintainability_index: 41.818,
                hostname_repo_full_name: "adadot / Code Quality",
                maintainability_influence: -11.077,
            },
            {
                maintainability_index: 52.648,
                hostname_repo_full_name: "adadot / devops / terraform",
                maintainability_influence: -1.807,
            },
            {
                maintainability_index: 38.79,
                hostname_repo_full_name: "adadot / Frontend B2C",
                maintainability_influence: -2.723,
            },
            {
                maintainability_index: 40.701,
                hostname_repo_full_name: "adadot / Github Events Webhooks",
                maintainability_influence: 1.678,
            },
            {
                maintainability_index: 70.757,
                hostname_repo_full_name: "adadot / mkdocs",
                maintainability_influence: -2.518,
            },
            {
                maintainability_index: 37.52,
                hostname_repo_full_name: "adadot / Redshift",
                maintainability_influence: -0.079,
            },
            {
                maintainability_index: 45.206,
                hostname_repo_full_name: "adadot / Service Events Webhooks",
                maintainability_influence: 0.233,
            },
            {
                maintainability_index: 57.756,
                hostname_repo_full_name: "adadot / slack",
                maintainability_influence: -4.15,
            },
            {
                maintainability_index: 45.407,
                hostname_repo_full_name: "adadot / utils",
                maintainability_influence: -1.526,
            },
        ],
        meta: {
            accuracy: {
                level: "high",
                dependencies: [
                    {
                        type: "integration",
                        name: "git",
                        impact: "very-high",
                        fulfilled: true,
                    },
                ],
            },
        },
        stats: {
            slope: 0.01927,
        },
    },
};

export default overviewMockData;
